import { ServiceTag } from '../models/interfaces';

export class ServiceTagUtils {
  public static isTreatmentCategory(serviceTag: ServiceTag): boolean {
    const regexToCheckCategory = new RegExp('^--.*--$');
    return regexToCheckCategory.test(serviceTag.tag);
  }
}
